export type TFieldSuffix =
  | 'AuxScore'
  | 'Position'
  | 'Score'
  | 'Tie'
  | 'Hole'
  | 'Eliminated'
  | 'Participating'
  | 'Strikes'
  | 'Winner';

export interface IMetaResult {
  clubId: number;
  enrollmentId: number;
  eventId: number;
  hole?: number;
  flightId: number;
  gameId: number;
  groupId: number;
  roundId: number;
  roundOrder: number;
  seasonId: number;

  userFirstName: string;
  userId: number;
  userImage: string;
  userLastName: string;
}

export interface IResult extends IMetaResult {
  handicap: number;
  qualified: boolean;
  through: number;

  horseFlightGrossEliminated: boolean;
  horseFlightGrossParticipating: boolean;
  horseFlightGrossScore: number;
  horseFlightGrossHole: number;
  horseFlightNetEliminated: boolean;
  horseFlightNetParticipating: boolean;
  horseFlightNetScore: number;
  horseFlightNetHole: number;

  horseRoundGrossEliminated: boolean;
  horseRoundGrossParticipating: boolean;
  horseRoundGrossScore: number;
  horseRoundGrossHole: number;
  horseRoundNetEliminated: boolean;
  horseRoundNetParticipating: boolean;
  horseRoundNetScore: number;
  horseRoundNetHole: number;

  strokeGrossAuxScore: number;
  strokeGrossPosition: number;
  strokeGrossScore: number;
  strokeGrossTie: boolean;
  strokeNetAuxScore: number;
  strokeNetPosition: number;
  strokeNetScore: number;
  strokeNetTie: boolean;

  strokeGrossStablefordAuxScore: number;
  strokeGrossStablefordPosition: number;
  strokeGrossStablefordScore: number;
  strokeGrossStablefordTie: boolean;
  strokeNetStablefordAuxScore: number;
  strokeNetStablefordPosition: number;
  strokeNetStablefordScore: number;
  strokeNetStablefordTie: boolean;

  horseScore: number;
  horseHole: number;
  horseStillRace: boolean;

  strikes?: number;
}

export interface IAdminRoundResultsStore {
  [roundId: number]: {
    [flightId: number]: IResult[];
  };
}

export const adminRoundResultsStore: IAdminRoundResultsStore = {};
